module.exports = __webpack_public_path__ + "assets/img/icon_nor_item.9808cc95.svg";